"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Product = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _utils = require("../../utils");
var _components = require("./components");
var _Price = require("./components/Price");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Product = ({
  shade,
  code,
  name,
  index,
  price,
  showBackInStockNotification
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.PRODUCT),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Info, {
      href: (0, _utils.getProductUrl)(code),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ShadeWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledShade, {
          shade: shade
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ProductInfo, {
        name: name,
        code: code
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.PriceAndButton, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Price.Price, {
        price: price
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButtons, {
        code: code,
        index: index,
        shade: shade,
        price: price,
        showBackInStockNotification: showBackInStockNotification
      })]
    })]
  });
};
exports.Product = Product;
//# sourceMappingURL=Product.js.map